import i18n from '../../../../../i18n';
import { STATUS_LABEL_TEXT } from '../constants';

const getProductStatusLabel = (status) => {
  if (!STATUS_LABEL_TEXT.has(status)) return '';

  return i18n.t(STATUS_LABEL_TEXT.get(status));
};

export default getProductStatusLabel;
